import React from 'react';

const FinalCTA = () => {
    return (
        <section className="py-24 bg-primary relative overflow-hidden" id="contacto">
            {/* Background decorative elements */}
            <div className="absolute bottom-0 right-0 w-80 h-80 bg-secondary/80 rounded-tl-[100px] -z-10"></div>
            <div className="absolute top-20 left-20 w-20 h-20 bg-white/40 rounded-full -z-10"></div>

            {/* Animated particles */}
            <div className="particle-container">
                {[...Array(12)].map((_, i) => (
                    <div
                        key={i}
                        className={`absolute rounded-full bg-white/20 particle-${i + 1}`}
                        style={{
                            width: `${Math.random() * 12 + 8}px`,
                            height: `${Math.random() * 12 + 8}px`,
                            top: `${Math.random() * 100}%`,
                            left: `${Math.random() * 100}%`,
                            animationDuration: `${Math.random() * 20 + 10}s`,
                            animationDelay: `${Math.random() * 5}s`
                        }}
                    ></div>
                ))}
            </div>

            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="flex flex-col lg:flex-row gap-16">
                    {/* Text content */}
                    <div className="lg:w-1/2 text-white">
                        <h2 className="text-4xl font-bold mb-6 animate-fadeIn">
                            ¿Listo para Transformar tu Negocio?
                        </h2>
                        <p className="text-xl text-white/90 mb-8 animate-fadeIn animation-delay-200">
                            Comienza tu viaje hacia un negocio más eficiente, rentable y centrado en el cliente hoy mismo.
                        </p>

                        <div className="flex flex-col gap-6 mb-10">
                            <div className="flex items-center gap-4 transform hover:translate-x-2 transition-transform duration-300">
                                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                                    {/* Icono de facilidad de uso */}
                                    <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h8m-8 6h16" />
                                    </svg>

                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold">Fácil de usar</h3>
                                    <p className="text-white/80">Diseñado para cualquier profesional, sin conocimientos técnicos</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-4 transform hover:translate-x-2 transition-transform duration-300">
                                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                                    <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M12 2a10 10 0 100 20 10 10 0 000-20z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2 12h20" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M12 2c2.5 2.5 4 6.3 4 10s-1.5 7.5-4 10c-2.5-2.5-4-6.3-4-10s1.5-7.5 4-10z" />
                                    </svg>

                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold">Presencia online inmediata</h3>
                                    <p className="text-white/80">Tu página web visible en Google desde el primer día</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-4 transform hover:translate-x-2 transition-transform duration-300">
                                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                                    {/* Icono de una campana de notificaciones */}
                                    <svg className='w-6 h-6 text-primary' stroke='currentColor' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                        <path d="m23.83 20-1.73-.7a3.22 3.22 0 0 1-1.05-2.3c0-2.29-.05-6.22-.05-6.37V8.92A7.76 7.76 0 0 0 13.43 1h-1.86A7.76 7.76 0 0 0 4 8.92V17a3.19 3.19 0 0 1-1.06 2.31L1.17 20a.49.49 0 0 0-.31.55.5.5 0 0 0 .49.41h6.72c.31 1.69 2.17 3 4.43 3s4.12-1.31 4.43-3h6.72a.5.5 0 0 0 .49-.41.49.49 0 0 0-.31-.55zM12.5 23a3.43 3.43 0 0 1-3.43-2h6.86a3.43 3.43 0 0 1-3.43 2zm-8.84-3A4.21 4.21 0 0 0 5 17V8.92A6.76 6.76 0 0 1 11.57 2h1.86A6.76 6.76 0 0 1 20 8.92v1.73c0 .15 0 4.08.05 6.39a4.18 4.18 0 0 0 1.3 3z" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold">Conectado en todo momento</h3>
                                    <p className="text-white/80">Recibí reservas y recordatorios en tu celular y correo</p>
                                </div>
                            </div>
                        </div>
                        <div className="animate-fadeIn animation-delay-400">
                            <div className="relative">
                                <div className="absolute inset-0 bg-secondary/25 blur-xl rounded-lg -z-10"></div>
                                <p className="text-2xl font-bold sm:mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white to-white/80">
                                    Contactate ahora y digitalizá tu negocio en minutos
                                </p>

                                {/* Contact options */}
                                <div className="flex flex-col gap-4 mt-4">
                                    <a
                                        href="https://wa.me/59892748021?text=Hola!%20Me%20interesa%20conocer%20más%20sobre%20Grovi%20para%20mi%20negocio"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-3 text-white hover:text-secondary transition-colors group"
                                    >
                                        <div className="w-10 h-10 bg-white/20 group-hover:bg-white rounded-full flex items-center justify-center transition-all">
                                            <svg className="w-5 h-5 text-white group-hover:text-primary transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16.72 12.73c-.25-.13-1.47-.72-1.7-.8-.23-.08-.4-.13-.57.13-.17.25-.65.8-.8.97-.15.17-.3.2-.55.07-.25-.13-1.05-.39-2-1.24-.74-.66-1.23-1.48-1.38-1.72-.15-.25-.02-.38.11-.5.12-.12.28-.3.42-.45.14-.15.18-.25.28-.42.1-.17.05-.32-.03-.45-.08-.13-.57-1.37-.78-1.87-.2-.48-.4-.42-.57-.43-.15-.01-.32-.01-.48-.01s-.45.07-.69.32c-.24.25-.91.89-.91 2.17s.93 2.51 1.06 2.68c.13.17 1.83 2.88 4.44 4.03.62.27 1.1.43 1.48.55.62.2 1.18.17 1.62.1.5-.07 1.47-.6 1.67-1.18.2-.58.2-1.07.15-1.18-.06-.11-.23-.18-.48-.3z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2C6.48 2 2 6.48 2 12c0 1.91.5 3.68 1.37 5.23L2 22l4.84-1.31A9.964 9.964 0 0012 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" />
                                            </svg>
                                        </div>
                                        <span className="text-lg">092748021</span>
                                    </a>

                                    <a
                                        href="mailto:hola@grovi.com.uy"
                                        className="flex items-center gap-3 text-white hover:text-secondary transition-colors group"
                                    >
                                        <div className="w-10 h-10 bg-white/20 group-hover:bg-white rounded-full flex items-center justify-center transition-all">
                                            <svg className="w-5 h-5 text-white group-hover:text-primary transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <span className="text-lg">hola@grovi.com.uy</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact form */}
                    <div className="lg:w-1/2 animate-fadeIn animation-delay-600">
                        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden transform transition-all duration-500 hover:shadow-[0_20px_50px_rgba(0,0,0,0.3)]">
                            <div className="p-8">
                                <h3 className="text-2xl font-bold text-secondary mb-6">Solicita Una Demo Personalizada</h3>

                                <form className="space-y-6" action="https://formspree.io/f/xovdoqdp" method="POST">
                                    <div className="grid md:grid-cols-2 gap-6">
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all duration-300"
                                                placeholder="Tu nombre"
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all duration-300"
                                                placeholder="tu@email.com"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">Nombre de Negocio</label>
                                        <input
                                            type="text"
                                            id="company"
                                            name="company"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all duration-300"
                                            placeholder="Nombre de tu negocio"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="business_type" className="block text-sm font-medium text-gray-700 mb-2">Tipo de Negocio</label>
                                        <select
                                            id="business_type"
                                            name="business_type"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all duration-300"
                                            required
                                        >
                                            <option value="">Selecciona una opción</option>
                                            <option value="spa">Spa / Centro de Bienestar</option>
                                            <option value="salon">Salón de Belleza</option>
                                            <option value="barbershop">Barbería</option>
                                            <option value="clinic">Clínica Estética</option>
                                            <option value="yoga">Estudio de Yoga</option>
                                            <option value="other">Otro</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Mensaje</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            rows="4"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all duration-300"
                                            placeholder="Cuéntanos más sobre tu negocio y tus necesidades..."
                                        ></textarea>
                                    </div>

                                    <div>
                                        <button
                                            type="submit"
                                            className="w-full py-4 px-6 bg-primary hover:opacity-90 text-white font-semibold rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl relative overflow-hidden group"
                                        >
                                            <span className="relative z-10">Enviar Solicitud</span>
                                            <div className="absolute inset-0 bg-gradient-to-r from-primary via-secondary to-primary bg-[length:200%] opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out bg-animate"></div>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Animations */}
            <style jsx="true">{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                
                @keyframes float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-20px); }
                }
                
                @keyframes float-particles {
                    0% { transform: translateY(0) translateX(0); }
                    25% { transform: translateY(-30px) translateX(15px); }
                    50% { transform: translateY(-60px) translateX(-15px); }
                    75% { transform: translateY(-30px) translateX(15px); }
                    100% { transform: translateY(0) translateX(0); }
                }
                
                @keyframes bg-slide {
                    0% { background-position: 0% 50%; }
                    100% { background-position: 100% 50%; }
                }
                
                .animate-fadeIn {
                    animation: fadeIn 1s ease-out forwards;
                }
                
                .animation-delay-200 {
                    animation-delay: 0.2s;
                }
                
                .animation-delay-400 {
                    animation-delay: 0.4s;
                }
                
                .animation-delay-600 {
                    animation-delay: 0.6s;
                }
                
                .particle-container div {
                    position: absolute;
                    animation: float-particles linear infinite;
                }
                
                .bg-animate {
                    animation: bg-slide 3s linear infinite;
                }
            `}</style>
        </section>
    );
};

export default FinalCTA; 
